import toThaiDateString from '../data_processor/date_convertor';
import toEngProvinceString from '../data_processor/province_convertor';

function firstDayOfWeek (year, week, view) {

    // Jan 1 of 'year'
    var d = new Date(year, 0, 1),
        offset = d.getTimezoneOffset();

    // ISO: week 1 is the one with the year's first Thursday 
    // so nearest Thursday: current date + 4 - current day number
    // Sunday is converted from 0 to 7
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));

    // 7 days * (week - overlapping first week)
    d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000 
        * (week + (year == d.getFullYear() ? -1 : 0 )));

    // daylight savings fix
    d.setTime(d.getTime() 
        + (d.getTimezoneOffset() - offset) * 60 * 1000);
    
    // back to Monday (from Thursday)
    d.setDate(d.getDate() - 3 + 5);

    return d;
}

const ThaiAndUniqueYear = (data, view, streamBoolean) => {

    let d = 0;
    let i = 0;

    /* View 1 variable */
    let view1_uniqueDateMonthProvince = [];
    let view1_uniqueDateMonthWhole = [];
    let view1_uniqueDateWeekProvince = [];
    let view1_uniqueDateWeekWhole = [];
    let view1_uniqueDateYearProvince = [];
    let view1_uniqueDateYearWhole = [];

    /* View 2 variable */
    let view2_uniqueDateMonthProvince = [];
    let view2_uniqueDateMonthWhole = [];
    let view2_uniqueDateWeekProvince = [];
    let view2_uniqueDateWeekWhole = [];
    let view2_uniqueDateYearProvince = [];
    let view2_uniqueDateYearWhole = [];

    /* View 3 variable */
    let view3_uniqueDateMonthGenderAge = [];
    let view3_uniqueDateWeekGenderAge = [];
    let view3_uniqueDateYearGenderAge = [];
    let view3_uniqueDateMonthAge = [];
    let view3_uniqueDateWeekAge = [];
    let view3_uniqueDateYearAge = [];
    
    /* View 4 variable */
    let view4_uniqueDateMonthProvince = [];
    let view4_uniqueDateWeekProvince = [];
    let view4_uniqueDateYearProvince = [];
    let view4_uniqueDateMonthProvince_all = [];
    let view4_uniqueDateWeekProvince_all = [];
    let view4_uniqueDateYearProvince_all = [];
    let view4_uniqueDateMonthWhole = [];
    let view4_uniqueDateWeekWhole = [];
    let view4_uniqueDateYearWhole = [];
    let view4_uniqueDateMonthWhole_all = [];
    let view4_uniqueDateWeekWhole_all = [];
    let view4_uniqueDateYearWhole_all = [];

    /* View 5 variable */
    let view5_uniqueDateMonthSingle = [];
    let view5_uniqueDateMonthAll = [];

    for(d=0;d<data.length;d++){
        if(streamBoolean){
            if (view === 1){
                if (d === 0){
                    for(i=0;i<data[d].view_1_month_province.length;i++){

                        let date = new Date(data[d].view_1_month_province[i].DYEAR, data[d].view_1_month_province[i].DMON-1, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_1_month_province[i].engDate = date;
                        data[d].view_1_month_province[i].Date = newDate[0];

                        if(!(view1_uniqueDateMonthProvince.includes(newDate[1]))){
                            view1_uniqueDateMonthProvince.push(newDate[1]);
                        }
                    }
                }
                else if (d === 1){
                        for(i=0;i<data[d].view_1_month_whole.length;i++){
                            let date = new Date(data[d].view_1_month_whole[i].DYEAR, data[d].view_1_month_whole[i].DMON-1, 1, 0, 0, 0, 0);
                            let newDate = toThaiDateString(date);

                            data[d].view_1_month_whole[i].Date = newDate[0];
                            data[d].view_1_month_whole[i].engDate = date;
                            
                            if(!(view1_uniqueDateMonthWhole.includes(newDate[1]))){
                                view1_uniqueDateMonthWhole.push(newDate[1]);
                            }
                        }
                    }
                else if (d === 2){
                    for(i=0;i<data[d].view_1_week_province.length;i++){      
                        let date = firstDayOfWeek(data[d].view_1_week_province[i].DYEAR, data[d].view_1_week_province[i].DWEEK);
                        if(date.getFullYear() != data[d].view_1_week_province[i].DYEAR && date.getMonth() != data[d].view_1_week_province[i].DMON){
                            date = new Date(`January 1, ${data[d].view_1_week_province[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);

                        data[d].view_1_week_province[i].engDate = date;
                        data[d].view_1_week_province[i].Date = newDate[0];
        
                        if(!(view1_uniqueDateWeekProvince.includes(newDate[1]))){
                            view1_uniqueDateWeekProvince.push(newDate[1]);
                        }
                    }
                }
                else if (d === 3){
                    for(i=0;i<data[d].view_1_week_whole.length;i++){
                        let date = firstDayOfWeek(data[d].view_1_week_whole[i].DYEAR, data[d].view_1_week_whole[i].DWEEK);
                        if(date.getFullYear() != data[d].view_1_week_whole[i].DYEAR && date.getMonth() != data[d].view_1_week_whole[i].DMON){
                            date = new Date(`January 1, ${data[d].view_1_week_whole[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);

                        data[d].view_1_week_whole[i].engDate = date;
                        data[d].view_1_week_whole[i].Date = newDate[0];
                        
                        if(!(view1_uniqueDateWeekWhole.includes(newDate[1]))){
                            view1_uniqueDateWeekWhole.push(newDate[1]);
                        }
                    }
                }
                else if (d === 4){
                    for(i=0;i<data[d].view_1_year_province.length;i++){
                        
                        let date = new Date(data[d].view_1_year_province[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_1_year_province[i].engDate = date;
                        data[d].view_1_year_province[i].Date = newDate[0];
        
                        if(!(view1_uniqueDateYearProvince.includes(newDate[1]))){
                            view1_uniqueDateYearProvince.push(newDate[1]);
                        }
                    }
                }
                else if (d === 5){
                    for(i=0;i<data[d].view_1_year_whole.length;i++){
                        
                        let date = new Date(data[d].view_1_year_whole[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);
        
                        data[d].view_1_year_whole[i].engDate = date;
                        data[d].view_1_year_whole[i].Date = newDate[0];
        
                        if(!(view1_uniqueDateYearWhole.includes(newDate[1]))){
                            view1_uniqueDateYearWhole.push(newDate[1]);
                        }
                    }
                }
            } else if (view === 2){
                    if (d === 0){
                        for(i=0;i<data[d].view_2_month_province.length;i++){

                            let date = new Date(data[d].view_2_month_province[i].DYEAR, data[d].view_2_month_province[i].DMON-1, 1, 0, 0, 0, 0);
                            let newDate = toThaiDateString(date);

                            data[d].view_2_month_province[i].engDate = date;
                            data[d].view_2_month_province[i].Date = newDate[0];

                            if(!(view2_uniqueDateMonthProvince.includes(newDate[1]))){
                                view2_uniqueDateMonthProvince.push(newDate[1]);
                            }
                        }
                    }
                    else if (d === 1){
                            for(i=0;i<data[d].view_2_month_whole.length;i++){
                                let date = new Date(data[d].view_2_month_whole[i].DYEAR, data[d].view_2_month_whole[i].DMON-1, 1, 0, 0, 0, 0);
                                let newDate = toThaiDateString(date);

                                data[d].view_2_month_whole[i].Date = newDate[0];
                                data[d].view_2_month_whole[i].engDate = date;
                                
                                if(!(view2_uniqueDateMonthWhole.includes(newDate[1]))){
                                    view2_uniqueDateMonthWhole.push(newDate[1]);
                                }
                            }
                    }
                    else if (d === 2){
                        for(i=0;i<data[d].view_2_week_province.length;i++){      
                            let date = firstDayOfWeek(data[d].view_2_week_province[i].DYEAR, data[d].view_2_week_province[i].DWEEK);
                            if(date.getFullYear() != data[d].view_2_week_province[i].DYEAR && date.getMonth() != data[d].view_2_week_province[i].DMON){
                                date = new Date(`January 1, ${data[d].view_2_week_province[i].DYEAR} 00:00:00`);
                            }
                            let newDate = toThaiDateString(date);

                            data[d].view_2_week_province[i].engDate = date;
                            data[d].view_2_week_province[i].Date = newDate[0];

                            if(!(view2_uniqueDateWeekProvince.includes(newDate[1]))){
                                view2_uniqueDateWeekProvince.push(newDate[1]);
                            }
                        }
                    }
                    else if (d === 3){
                        for(i=0;i<data[d].view_2_week_whole.length;i++){
                            let date = firstDayOfWeek(data[d].view_2_week_whole[i].DYEAR, data[d].view_2_week_whole[i].DWEEK);
                            if(date.getFullYear() != data[d].view_2_week_whole[i].DYEAR && date.getMonth() != data[d].view_2_week_whole[i].DMON){
                                date = new Date(`January 1, ${data[d].view_2_week_whole[i].DYEAR} 00:00:00`);
                            }
                            let newDate = toThaiDateString(date);

                            data[d].view_2_week_whole[i].engDate = date;
                            data[d].view_2_week_whole[i].Date = newDate[0];
                            
                            if(!(view2_uniqueDateWeekWhole.includes(newDate[1]))){
                                view2_uniqueDateWeekWhole.push(newDate[1]);
                            }
                        }
                    }
                    else if (d === 4){
                        for(i=0;i<data[d].view_2_year_province.length;i++){
                            
                            let date = new Date(data[d].view_2_year_province[i].DYEAR, 0, 1, 0, 0, 0, 0);
                            let newDate = toThaiDateString(date);
                            // let engProvince = toEngProvinceString(data[d].view_2_year_province[i].PROVINCE_D);
                            // let date_num = formatDate(date);

                            // data[d].view_2_year_province[i].numDate = date_num;

                            data[d].view_2_year_province[i].engDate = date;
                            data[d].view_2_year_province[i].Date = newDate[0];
                            // data[d].view_2_year_province[i].EngProvince = engProvince;

                            if(!(view2_uniqueDateYearProvince.includes(newDate[1]))){
                                view2_uniqueDateYearProvince.push(newDate[1]);
                            }
                        }
                    }
                    else if (d === 5){
                        for(i=0;i<data[d].view_2_year_whole.length;i++){
                            
                            let date = new Date(data[d].view_2_year_whole[i].DYEAR, 0, 1, 0, 0, 0, 0);
                            
                            // let date = new Date(data[d].view_1_day_whole[i].Date);
                            // let engBuddhistDate = new Date(date.setFullYear(date.getFullYear() + 543));
                            let newDate = toThaiDateString(date);
                            // let engProvince = toEngProvinceString(data[d].view_1_year_whole[i].PROVINCE_D);
                            // let date_num = formatDate(date);

                            // data[d].view_2_year_whole[i].numDate = date_num;

                            data[d].view_2_year_whole[i].engDate = date;
                            data[d].view_2_year_whole[i].Date = newDate[0];
                            // data[d].view_1_year_whole[i].EngProvince = engProvince;

                            if(!(view2_uniqueDateYearWhole.includes(newDate[1]))){
                                view2_uniqueDateYearWhole.push(newDate[1]);
                            }
                        }
                    }
            } else if (view === 3){
                if (d === 0){
                    for(i=0;i<data[d].view_3_month_gender_age.length;i++){

                        let date = new Date(data[d].view_3_month_gender_age[i].DYEAR, data[d].view_3_month_gender_age[i].DMON-1, 1, 0, 0, 0, 0);
                        // let date = new Date(data[d].view_3_month_gender_age[i].Date);
                        // let engBuddhistDate = new Date(date.setFullYear(date.getFullYear() + 543));
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);

                        // data[d].view_3_month_gender_age[i].numDate = date_num;
                        data[d].view_3_month_gender_age[i].engDate = date;
                        data[d].view_3_month_gender_age[i].Date = newDate[0];
                        // data[d].view_3_month_gender_age[i].Gender = toThaiGenderString(data[d].view_3_month_gender_age[i].Gender);

                        if(!(view3_uniqueDateMonthGenderAge.includes(newDate[1]))){
                            view3_uniqueDateMonthGenderAge.push(newDate[1]);
                        }
                    }
                }
                else if (d === 1){
                    for(i=0;i<data[d].view_3_week_gender_age.length;i++){

                        let date = firstDayOfWeek(data[d].view_3_week_gender_age[i].DYEAR, data[d].view_3_week_gender_age[i].DWEEK);
                        if(date.getFullYear() != data[d].view_3_week_gender_age[i].DYEAR && date.getMonth() != data[d].view_3_week_gender_age[i].DMON){
                            date = new Date(`January 1, ${data[d].view_3_week_gender_age[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);

                        // data[d].view_3_week_gender_age[i].numDate = date_num;
                        data[d].view_3_week_gender_age[i].engDate = date;
                        data[d].view_3_week_gender_age[i].Date = newDate[0];
                        
                        if(!(view3_uniqueDateWeekGenderAge.includes(newDate[1]))){
                            view3_uniqueDateWeekGenderAge.push(newDate[1]);
                        }
                    }
                }
                else if (d === 2){
                    for(i=0;i<data[d].view_3_year_gender_age.length;i++){

                        let date = new Date(data[d].view_3_year_gender_age[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);

                        // data[d].view_3_year_gender_age[i].numDate = date_num;
                        data[d].view_3_year_gender_age[i].engDate = date;
                        data[d].view_3_year_gender_age[i].Date = newDate[0];
                        
                        if(!(view3_uniqueDateYearGenderAge.includes(newDate[1]))){
                            view3_uniqueDateYearGenderAge.push(newDate[1]);
                        }
                    }
                }
                else if (d === 3){
                    for(i=0;i<data[d].view_3_month_age.length;i++){

                        let date = new Date(data[d].view_3_month_age[i].DYEAR, data[d].view_3_month_age[i].DMON-1, 1, 0, 0, 0, 0);
                        // let date = new Date(data[d].view_3_month_gender_age[i].Date);
                        // let engBuddhistDate = new Date(date.setFullYear(date.getFullYear() + 543));
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);

                        // data[d].view_3_month_gender_age[i].numDate = date_num;
                        data[d].view_3_month_age[i].engDate = date;
                        data[d].view_3_month_age[i].Date = newDate[0];
                        // data[d].view_3_month_gender_age[i].Gender = toThaiGenderString(data[d].view_3_month_gender_age[i].Gender);

                        if(!(view3_uniqueDateMonthAge.includes(newDate[1]))){
                            view3_uniqueDateMonthAge.push(newDate[1]);
                        }
                    }
                }
                else if (d === 4){
                    for(i=0;i<data[d].view_3_week_age.length;i++){

                        let date = firstDayOfWeek(data[d].view_3_week_age[i].DYEAR, data[d].view_3_week_age[i].DWEEK);
                        if(date.getFullYear() != data[d].view_3_week_age[i].DYEAR && date.getMonth() != data[d].view_3_week_age[i].DMON){
                            date = new Date(`January 1, ${data[d].view_3_week_age[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);

                        // data[d].view_3_week_gender_age[i].numDate = date_num;
                        data[d].view_3_week_age[i].engDate = date;
                        data[d].view_3_week_age[i].Date = newDate[0];
                        
                        if(!(view3_uniqueDateWeekAge.includes(newDate[1]))){
                            view3_uniqueDateWeekAge.push(newDate[1]);
                        }
                    }
                }
                else if (d === 5){
                    for(i=0;i<data[d].view_3_year_age.length;i++){

                        let date = new Date(data[d].view_3_year_age[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);

                        // data[d].view_3_year_gender_age[i].numDate = date_num;
                        data[d].view_3_year_age[i].engDate = date;
                        data[d].view_3_year_age[i].Date = newDate[0];
                        
                        if(!(view3_uniqueDateYearAge.includes(newDate[1]))){
                            view3_uniqueDateYearAge.push(newDate[1]);
                        }
                    }
                }
            } else if (view === 4){
                if (d === 0){
                    for(i=0;i<data[d].view_4_month_province.length;i++){

                        // let date = new Date(data[d].view_4_month[i].Date);
                        let date = new Date(data[d].view_4_month_province[i].DYEAR, data[d].view_4_month_province[i].DMON-1, 1, 0, 0, 0, 0);
                        // let engBuddhistDate = new Date(date.setFullYear(date.getFullYear() + 543));
                        let newDate = toThaiDateString(date);
                        // let engProvince = toEngProvinceString(data[d].view_4_month_province[i].PROVINCE);
                        // let date_num = formatDate(date);

                        // data[d].view_4_month_province[i].numDate = date_num;
                        // data[d].view_4_month_province[i].EngProvince = engProvince;
                        data[d].view_4_month_province[i].engDate = date;
                        data[d].view_4_month_province[i].Date = newDate[0];
                        // data[d].view_4_month[i].CoD = toThaiCODString(data[d].view_4_month[i].CoD);
                        // data[d].view_4_month[i]['Place of Death'] = toThaiPlaceString(data[d].view_4_month[i]['Place of Death']);

                        if(!(view4_uniqueDateMonthProvince.includes(newDate[1]))){
                            view4_uniqueDateMonthProvince.push(newDate[1]);
                        }
                    }
                } else if (d === 1){
                    for(i=0;i<data[d].view_4_week_province.length;i++){

                        // let date = new Date(data[d].view_4_week[i].Date);

                        let date = firstDayOfWeek(data[d].view_4_week_province[i].DYEAR, data[d].view_4_week_province[i].DWEEK);
                        if(date.getFullYear() != data[d].view_4_week_province[i].DYEAR && date.getMonth() != data[d].view_4_week_province[i].DMON){
                            date = new Date(`January 1, ${data[d].view_4_week_province[i].DYEAR} 00:00:00`);
                        }
                        // let engBuddhistDate = new Date(date.setFullYear(date.getFullYear() + 543));
                        let newDate = toThaiDateString(date);
                        // let date_num = formatDate(date);
                        // // let engProvince = toEngProvinceString(data[d].view_4_week_province[i].PROVINCE);

                        // // data[d].view_4_week_province[i].EngProvince = engProvince;
                        // data[d].view_4_week_province[i].numDate = date_num;
                        data[d].view_4_week_province[i].engDate = date;
                        data[d].view_4_week_province[i].Date = newDate[0];
                        // data[d].view_4_week[i].CoD = toThaiCODString(data[d].view_4_week[i].CoD);
                        // data[d].view_4_week[i]['Place of Death'] = toThaiPlaceString(data[d].view_4_week[i]['Place of Death']);

                        if(!(view4_uniqueDateWeekProvince.includes(newDate[1]))){
                            view4_uniqueDateWeekProvince.push(newDate[1]);
                        }
                    }
                } else if (d === 2){
                    for(i=0;i<data[d].view_4_year_province.length;i++){
                        
                        let date = new Date(data[d].view_4_year_province[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        // let date = new Date(data[d].view_1_day_province[i].Date);
                        // let engBuddhistDate = new Date(date.setFullYear(date.getFullYear() + 543));
                        let newDate = toThaiDateString(date);
                        // let engProvince = toEngProvinceString(data[d].view_4_year_province[i].PROVINCE);
                        // let date_num = formatDate(date);

                        // data[d].view_4_year_province[i].numDate = date_num;
                        data[d].view_4_year_province[i].engDate = date;
                        data[d].view_4_year_province[i].Date = newDate[0];
                        // data[d].view_4_year_province[i].EngProvince = engProvince;
                        
                        if(!(view4_uniqueDateYearProvince.includes(newDate[1]))){
                            view4_uniqueDateYearProvince.push(newDate[1]);
                        }
                    }
                } else if (d === 3){
                    for(i=0;i<data[d].view_4_month_province_all.length;i++){
                        let date = new Date(data[d].view_4_month_province_all[i].DYEAR, data[d].view_4_month_province_all[i].DMON-1, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_4_month_province_all[i].engDate = date;
                        data[d].view_4_month_province_all[i].Date = newDate[0];
                        // data[d].view_4_month_province_all[i].EngProvince = engProvince;
                        
                        if(!(view4_uniqueDateMonthProvince_all.includes(newDate[1]))){
                            view4_uniqueDateMonthProvince_all.push(newDate[1]);
                        }
                    }
                } else if (d === 4){
                    for(i=0;i<data[d].view_4_week_province_all.length;i++){
                        let date = firstDayOfWeek(data[d].view_4_week_province_all[i].DYEAR, data[d].view_4_week_province_all[i].DWEEK);
                        if(date.getFullYear() != data[d].view_4_week_province_all[i].DYEAR && date.getMonth() != data[d].view_4_week_province_all[i].DMON){
                            date = new Date(`January 1, ${data[d].view_4_week_province_all[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);

                        data[d].view_4_week_province_all[i].engDate = date;
                        data[d].view_4_week_province_all[i].Date = newDate[0];

                        if(!(view4_uniqueDateWeekProvince_all.includes(newDate[1]))){
                            view4_uniqueDateWeekProvince_all.push(newDate[1]);
                        }
                    }
                } else if (d === 5){
                    for(i=0;i<data[d].view_4_year_province_all.length;i++){                   
                        let date = new Date(data[d].view_4_year_province_all[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_4_year_province_all[i].engDate = date;
                        data[d].view_4_year_province_all[i].Date = newDate[0];
                        
                        if(!(view4_uniqueDateYearProvince_all.includes(newDate[1]))){
                            view4_uniqueDateYearProvince_all.push(newDate[1]);
                        }
                    }
                } else if (d === 6){
                    for(i=0;i<data[d].view_4_month_whole.length;i++){
                        let date = new Date(data[d].view_4_month_whole[i].DYEAR, data[d].view_4_month_whole[i].DMON-1, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_4_month_whole[i].engDate = date;
                        data[d].view_4_month_whole[i].Date = newDate[0];
                        
                        if(!(view4_uniqueDateMonthWhole.includes(newDate[1]))){
                            view4_uniqueDateMonthWhole.push(newDate[1]);
                        }
                    }
                } else if (d === 7){
                    for(i=0;i<data[d].view_4_week_whole.length;i++){
                        let date = firstDayOfWeek(data[d].view_4_week_whole[i].DYEAR, data[d].view_4_week_whole[i].DWEEK);
                        if(date.getFullYear() != data[d].view_4_week_whole[i].DYEAR && date.getMonth() != data[d].view_4_week_whole[i].DMON){
                            date = new Date(`January 1, ${data[d].view_4_week_whole[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);

                        data[d].view_4_week_whole[i].engDate = date;
                        data[d].view_4_week_whole[i].Date = newDate[0];

                        if(!(view4_uniqueDateWeekWhole.includes(newDate[1]))){
                            view4_uniqueDateWeekWhole.push(newDate[1]);
                        }
                    }
                } else if (d === 8){
                    for(i=0;i<data[d].view_4_year_whole.length;i++){         
                        let date = new Date(data[d].view_4_year_whole[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_4_year_whole[i].engDate = date;
                        data[d].view_4_year_whole[i].Date = newDate[0];
                        
                        if(!(view4_uniqueDateYearWhole.includes(newDate[1]))){
                            view4_uniqueDateYearWhole.push(newDate[1]);
                        }
                    }
                } else if (d === 9){
                    for(i=0;i<data[d].view_4_month_whole_all.length;i++){
                        let date = new Date(data[d].view_4_month_whole_all[i].DYEAR, data[d].view_4_month_whole_all[i].DMON-1, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_4_month_whole_all[i].engDate = date;
                        data[d].view_4_month_whole_all[i].Date = newDate[0];
                        
                        if(!(view4_uniqueDateMonthWhole_all.includes(newDate[1]))){
                            view4_uniqueDateMonthWhole_all.push(newDate[1]);
                        }
                    }
                } else if (d === 10){
                    for(i=0;i<data[d].view_4_week_whole_all.length;i++){
                        let date = firstDayOfWeek(data[d].view_4_week_whole_all[i].DYEAR, data[d].view_4_week_whole_all[i].DWEEK);
                        if(date.getFullYear() != data[d].view_4_week_whole_all[i].DYEAR && date.getMonth() != data[d].view_4_week_whole_all[i].DMON){
                            date = new Date(`January 1, ${data[d].view_4_week_whole_all[i].DYEAR} 00:00:00`);
                        }
                        let newDate = toThaiDateString(date);

                        data[d].view_4_week_whole_all[i].engDate = date;
                        data[d].view_4_week_whole_all[i].Date = newDate[0];

                        if(!(view4_uniqueDateWeekWhole_all.includes(newDate[1]))){
                            view4_uniqueDateWeekWhole_all.push(newDate[1]);
                        }
                    }
                } else if (d === 11){
                    for(i=0;i<data[d].view_4_year_whole_all.length;i++){               
                        let date = new Date(data[d].view_4_year_whole_all[i].DYEAR, 0, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);

                        data[d].view_4_year_whole_all[i].engDate = date;
                        data[d].view_4_year_whole_all[i].Date = newDate[0];
                        
                        if(!(view4_uniqueDateYearWhole_all.includes(newDate[1]))){
                            view4_uniqueDateYearWhole_all.push(newDate[1]);
                        }
                    }
                }
            } else if (view === 5){
                if (d === 0){
                    for(i=0;i<data[d].view_5_single.length;i++){
                        let date = new Date(data[d].view_5_single[i].DYEAR, data[d].view_5_single[i].DMON-1, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);
                        let engProvince = toEngProvinceString(data[d].view_5_single[i].PROVINCE);

                        data[d].view_5_single[i].EngProvince = engProvince;
                        data[d].view_5_single[i].engDate = date;
                        data[d].view_5_single[i].Date = newDate[0];
                        
                        if(!(view5_uniqueDateMonthSingle.includes(newDate[1]))){
                            view5_uniqueDateMonthSingle.push(newDate[1]);
                        }
                    }
                } else if (d === 1){
                    for(i=0;i<data[d].view_5_all.length;i++){
                        let date = new Date(data[d].view_5_all[i].DYEAR, data[d].view_5_all[i].DMON-1, 1, 0, 0, 0, 0);
                        let newDate = toThaiDateString(date);
                        let engProvince = toEngProvinceString(data[d].view_5_all[i].PROVINCE);

                        data[d].view_5_all[i].EngProvince = engProvince;
                        data[d].view_5_all[i].engDate = date;
                        data[d].view_5_all[i].Date = newDate[0];
                        
                        if(!(view5_uniqueDateMonthAll.includes(newDate[1]))){
                            view5_uniqueDateMonthAll.push(newDate[1]);
                        }
                    }
                }
            }
        }
    }
        let uniqueDate = {};

        if(streamBoolean){
            if(view === 1){
                uniqueDate = {
                    "uniqueDateMonthProvince": view1_uniqueDateMonthProvince, 
                    "uniqueDateMonthWhole": view1_uniqueDateMonthWhole,
                    "uniqueDateWeekProvince": view1_uniqueDateWeekProvince, 
                    "uniqueDateWeekWhole": view1_uniqueDateWeekWhole,
                    "uniqueDateYearWhole": view1_uniqueDateYearWhole, 
                    "uniqueDateYearProvince": view1_uniqueDateYearProvince,
                }
            } else if(view === 2){
                uniqueDate = {
                    "uniqueDateMonthProvince": view2_uniqueDateMonthProvince, 
                    "uniqueDateMonthWhole": view2_uniqueDateMonthWhole,
                    "uniqueDateWeekProvince": view2_uniqueDateWeekProvince, 
                    "uniqueDateWeekWhole": view2_uniqueDateWeekWhole,
                    "uniqueDateYearWhole": view2_uniqueDateYearWhole, 
                    "uniqueDateYearProvince": view2_uniqueDateYearProvince,
                }
            } else if(view === 3){
                uniqueDate = {
                    "uniqueDateMonthGenderAge": view3_uniqueDateMonthGenderAge, 
                    "uniqueDateWeekGenderAge": view3_uniqueDateWeekGenderAge, 
                    "uniqueDateYearGenderAge": view3_uniqueDateYearGenderAge, 
                    "uniqueDateMonthAge": view3_uniqueDateMonthAge, 
                    "uniqueDateWeekAge": view3_uniqueDateWeekAge, 
                    "uniqueDateYearAge": view3_uniqueDateYearAge, 
                }
            } else if(view === 4){
                uniqueDate = {
                    "uniqueDateMonthProvince": view4_uniqueDateMonthProvince, 
                    "uniqueDateWeekProvince": view4_uniqueDateWeekProvince,
                    "uniqueDateYearProvince": view4_uniqueDateYearProvince,
                    "uniqueDateMonthProvince_all": view4_uniqueDateMonthProvince_all, 
                    "uniqueDateWeekProvince_all": view4_uniqueDateWeekProvince_all,
                    "uniqueDateYearProvince_all": view4_uniqueDateYearProvince_all,
                    "uniqueDateMonthWhole": view4_uniqueDateMonthWhole, 
                    "uniqueDateWeekWhole": view4_uniqueDateWeekWhole,
                    "uniqueDateYearWhole": view4_uniqueDateYearWhole,
                    "uniqueDateMonthWhole_all": view4_uniqueDateMonthWhole_all, 
                    "uniqueDateWeekWhole_all": view4_uniqueDateWeekWhole_all,
                    "uniqueDateYearWhole_all": view4_uniqueDateYearWhole_all
                }
            } else if(view === 5){
                uniqueDate = {
                    "uniqueDateMonthSingle": view5_uniqueDateMonthSingle,
                    "uniqueDateMonthAll": view5_uniqueDateMonthAll,
                }
            }
        } else {
            if(view === 1){
                uniqueDate = {
                    "uniqueDateMonthProvince": view1_uniqueDateMonthProvince, 
                    "uniqueDateMonthWhole": view1_uniqueDateMonthWhole
                }
            } else if(view === 2){
                uniqueDate = {
                    "uniqueDateMonthProvince": view2_uniqueDateMonthProvince, 
                    "uniqueDateMonthWhole": view2_uniqueDateMonthWhole
                }
            } else if(view === 3){
                uniqueDate = {
                    "uniqueDateMonthGenderAge": view3_uniqueDateMonthGenderAge, 
                }
            }
        }
        const ThaiData = [...data];

        return {ThaiData, uniqueDate};
    
    }
export default ThaiAndUniqueYear;